import { route } from "preact-router"

import { allAgendas } from "../data/agendas"
import { useDateTime } from "../utils"
import * as styles from "../styles"
import { Column, Row } from "./layout"


const hasStarted = session => new Date(session.start) < new Date()
const hasNotStarted = session => !hasStarted(session)
const hasEnded = session => new Date(session.end) < new Date()
const hasNotEnded = session => !hasEnded(session)
const isOnNow = session => (
	hasStarted(session) && hasNotEnded(session)
)
const isSessionInRoom = room => session => session.room === room
const getDisplayTime = date => `${date.getHours() >= 10 ? date.getHours() : `0${date.getHours()}`}:${date.getMinutes() > 10 ? date.getMinutes() : `0${date.getMinutes()}`}`

const bucketBy = propertyName => (acc, item) => {
	const seenPropertyBefore = acc.hasOwnProperty(item[propertyName])
	if (seenPropertyBefore) {
		return {...acc, [item[propertyName]]: [...acc[item[propertyName]], item]}
	}	else {
		return {...acc, [item[propertyName]]: [item]}
	}
}

const uniqueReducer = propertyName => (acc, item) => (
	acc.includes(item[propertyName])
		? [...acc]
		: [...acc, item[propertyName]]
)

export const WhatsOnBreakouts = () => {
	const rooms = ["Breakout One", "Breakout Two", "Breakout Three", "Breakout Four"]

	return <Row styleOverride={{...styles.ffill, maxWidth: "1000px", flexWrap: "wrap"}}>
		{rooms.map(room => <WhatsOn room={room} />)}
	</Row>
}

export const WhatsOnEverywhere = () => {
	const rooms = allAgendas.reduce(uniqueReducer("room"), [])

	return <Row styleOverride={{...styles.ffill, maxWidth: "1000px", flexWrap: "wrap"}}>
		{rooms.map(room => <WhatsOn room={room} />)}
	</Row>
}

export const WhatsOn = ({room, containerStyle = {}, roomStyle = {}}) => {
	useDateTime()
	const eventStyle = {...styles.fc, ...styles.fcenter, justifyContent: "center", margin: "5px 10px", padding: "5px 10px", textAlign: "center", ...roomStyle}

	const roomSessions = allAgendas.filter(isSessionInRoom(room))
	const currentSession = roomSessions.find(isOnNow)
	const nextSession = roomSessions.find(hasNotStarted)

	return <Column
		class="whatson"
		styleOverride={{
			...styles.flex,
			alignContent: "stretch",
			justifyContent: "start",
			marginTop: "10px",
			marginBottom: "20px",
			color: "white",
			minWidth: "300px",
			maxWidth: "460px",
			flexBasis: "50%",
			flexGrow: 1,
			...containerStyle
		}}
	>
		<h3 style={{margin: 0, textAlign: "center"}}>{room}</h3>
		{
			currentSession
			? <WhatsOnItem
				style={eventStyle}
				heading="Now:"
				href={currentSession.path}
				title={currentSession.title}
			/>
			: <WhatsOnItem
				style={eventStyle}
				heading="Now:"
				title="Currently idle"
			/>
		}
		{
			nextSession
			&& <WhatsOnItem
				style={eventStyle}
				heading={`Next @ ${getDisplayTime(new Date(nextSession.start))}:`}
				href={nextSession.path}
				title={nextSession.title}
			/>
		}
	</Column>
}

const WhatsOnItem = ({heading, start, href, title, style = {}}) => {
	const onClick = href ? () => route(href) : null
	const styleOverride = {...style, cursor: (href ? "pointer" : "initial")}
	return <Column onClick={onClick} styleOverride={styleOverride} class="event">
		<span>{heading}</span>
		<span style={{margin: "0"}} class="name">{title || "Nothing"}</span>
	</Column>
}
